import { SkillsMainContainer } from 'src/components/Skills/SkillsMainContainer/SkillsMainContainer';
import { useGetEmployeeSkills } from './hooks/useGetEmployeeSkills';
import {
  SkillsContainer,
  SkillsTabContainer,
  SkillsWidgetsContainer,
} from './styles/Skills.styled';
import { SkillsWidgets } from 'src/components/Skills/SkillsWidgetsContainer/SkillsWidgets';
import { useGetExpertEmployees } from './hooks/useGetExpertEmployees';
import { useGetAllCategories } from './hooks/useGetAllCategories';
import { useGetSkillsByCategory } from './hooks/useGetSkillsByCategory';
import { useContext, useMemo } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useAlertMessage } from 'src/hooks/useAlertMessage';
import { Alert } from 'src/components/common/AlertMessage/AlertMessage';

export const Skills = () => {
  const { employeeSkills, getEmployeeSkills, loadingEmployeeSkills } =
    useGetEmployeeSkills();
  const { skillsByCategory, handleCategoryChange } = useGetSkillsByCategory();
  const { categories, loadingCategories } = useGetAllCategories();
  const { expertEmployees, getExperts, clearExperts, loadingExperts } =
    useGetExpertEmployees();
  const { isMobile } = useContext(TeamsFxContext);
  const {
    hideAlert,
    requestStatusAppearance,
    requestStatusMessage,
    showAlert,
  } = useAlertMessage();

  const existingSkillIds = useMemo(() => {
    return employeeSkills.reduce((acc, curr) => {
      const skillIds = curr.employeeSkills.map((data) => data.skill.id);
      return [...acc, ...skillIds];
    }, [] as string[]);
  }, [employeeSkills]);

  if (loadingCategories || loadingEmployeeSkills) return null;

  return (
    <SkillsContainer>
      {requestStatusMessage && (
        <Alert
          overlay={true}
          handleClose={hideAlert}
          requestStatusAppearance={requestStatusAppearance}
          requestStatusMessage={requestStatusMessage}
        />
      )}
      {isMobile ? (
        <SkillsTabContainer>
          <SkillsMainContainer
            showAlert={showAlert}
            employeeSkills={employeeSkills}
            existingSkillIds={existingSkillIds}
            skillsByCategory={skillsByCategory}
            categories={categories}
            getSkills={getEmployeeSkills}
            getExperts={getExperts}
            clearExperts={clearExperts}
            expertEmployees={expertEmployees}
            loadingExperts={loadingExperts}
            getEmployeeSkills={getEmployeeSkills}
            handleCategoryChange={handleCategoryChange}
          />
        </SkillsTabContainer>
      ) : (
        <>
          <SkillsTabContainer>
            <SkillsMainContainer
              employeeSkills={employeeSkills}
              existingSkillIds={existingSkillIds}
              skillsByCategory={skillsByCategory}
              categories={categories}
              getSkills={getEmployeeSkills}
              getEmployeeSkills={getEmployeeSkills}
              handleCategoryChange={handleCategoryChange}
              getExperts={getExperts}
              clearExperts={clearExperts}
              expertEmployees={expertEmployees}
              loadingExperts={loadingExperts}
              showAlert={showAlert}
            />
          </SkillsTabContainer>
          <SkillsWidgetsContainer>
            <SkillsWidgets
              categories={categories}
              expertEmployees={expertEmployees}
              getExperts={getExperts}
              skillsByCategory={skillsByCategory}
              handleCategoryChange={handleCategoryChange}
              clearExperts={clearExperts}
              loadingExperts={loadingExperts}
            />
          </SkillsWidgetsContainer>
        </>
      )}
    </SkillsContainer>
  );
};
